import { render, staticRenderFns } from "./LumbreApp.vue?vue&type=template&id=06fd6cee&scoped=true"
import script from "./LumbreApp.vue?vue&type=script&lang=js"
export * from "./LumbreApp.vue?vue&type=script&lang=js"
import style0 from "./LumbreApp.vue?vue&type=style&index=0&id=06fd6cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd6cee",
  null
  
)

export default component.exports